import React from "react";

import { css } from "@compiled/react";

import { fontFamily } from "@atlaskit/theme";

import AccountDetails from "./components/account-details";
import DefaultHeader from "./components/default-header";
import SiteSelectorForm from "./components/site-selector-form";

export type SiteSelectorViewProps = {
    readonly userName: string;
    readonly userEmail: string;
    readonly sites: string[];

    readonly header?: React.ReactNode;

    readonly onNewSiteSelected: () => void;
    readonly onSiteSelected: (site: string) => void;
    readonly onSiteChanged: () => void;
    readonly onSwitchAccountClick: () => void;
    readonly onCancelClick: () => void;

    readonly avatarSrc?: string;
    readonly fullScreenView?: boolean;
};

const SiteSelectorView = ({
    userName,
    userEmail,
    sites,
    avatarSrc,
    header,
    onNewSiteSelected,
    onSiteSelected,
    onSwitchAccountClick,
    onCancelClick,
    onSiteChanged,
    fullScreenView
}: SiteSelectorViewProps) => {
    return (
        <div css={rootContainerStyle}>
            <div css={headerStyle}>
                {header !== undefined ? header : <DefaultHeader />}
            </div>
            <div css={avatarContainerStyle}>
                <AccountDetails
                    userName={userName}
                    userEmail={userEmail}
                    avatarSrc={avatarSrc}
                />
            </div>
            <div>
                <SiteSelectorForm
                    sites={sites}
                    onNewSiteSelected={onNewSiteSelected}
                    onSiteSelected={onSiteSelected}
                    onSwitchAccountClick={onSwitchAccountClick}
                    onCancelClick={onCancelClick}
                    onSiteChanged={onSiteChanged}
                    fullScreenView={fullScreenView}
                />
            </div>
        </div>
    );
};

const rootContainerStyle = css({
    fontFamily: fontFamily
});

const headerStyle = css({
    fontFamily:
        "Charlie Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif"
});

const avatarContainerStyle = css({
    margin: "20px 0px"
});

export default SiteSelectorView;
